import deferredComponent from './components/deferredComponent';
import AppCredentials from './components/AppCredentials';
import AppBotScript from '@/components/AppBotScript';
import DeviceHistory from '@/components/DeviceHistory';
import DeviceUserList from '@/components/DeviceUserList';
import MobileWifiModule from '@/components/MobileWifiModule';
import WifiModuleIndex from '@/pages/personal/devices/wifi-module';
import IrTypeList from '@/pages/personal/devices/wifi-module/ir/ir-type-list';
import Learn from '@/pages/personal/devices/wifi-module/ir/learn';
import RemoteAir from '@/pages/personal/devices/wifi-module/ir/remote-air';
import RemoteList from '@/pages/personal/devices/wifi-module/ir/remote-list';
import RemoteMatch from '@/pages/personal/devices/wifi-module/ir/remote-match';
import RemoteNonAir from '@/pages/personal/devices/wifi-module/ir/remote-non-air';
import FactoryInfoDetail from '@biz/devices/factory-info';
import Vision from '@biz/vision';
import UpgradeSSMFirmware from '@components/biz/device/UpgradeSSMFirmware';
import Contacts from '@personal/contacts';
import Devices from '@personal/devices';
import Me from '@personal/me';
import DeviceSetting from './components/DeviceSetting';
import AppAutoUnlock from './components/AppAutoUnlock';
import AppLockAngle from './components/AppLockAngle';
import {
  SesameMobileBatteryChart,
  SesameMobileContactAdd,
  SesameMobileDeviceModifyName,
  SesameMobileDeviceSetting,
  SesameMobileDeviceShareQRCode,
  SesameMobileMeIndex,
  SesameMobileNotifyCenter,
  SesameMobileMyHomepage,
} from './components/index';

const VCards = deferredComponent(() => import('@biz/access-control/cards/cards'));
const PasswordDetails = deferredComponent(() => import('@biz/access-control/password/passworddetails'));
const Passwords = deferredComponent(() => import('@biz/access-control/password/passwords'));
const SesameAccessControlDeviceRegion = deferredComponent(() => import('@biz/access-control/region/region'));
const Cards = deferredComponent(() => import('@biz/cards'));
const CardDetails = deferredComponent(() => import('@biz/cards/details/carddetails'));
const Developer = deferredComponent(() => import('@biz/developer'));
const EnvSnapshotDetail = deferredComponent(() => import('@biz/history/env-snapshot'));
const DeviceShare = deferredComponent(() => import('@biz/devices/device-share/DeviceShare'));
const DeviceGroupItem = deferredComponent(() => import('@biz/devices/group-item/DeviceGroupItem'));
const GroupShare = deferredComponent(() => import('@biz/devices/group-share/GroupShare'));
const DeviceGroup = deferredComponent(() => import('@biz/devices/group/DeviceGroup'));
const DeviceItem = deferredComponent(() => import('@biz/devices/list-item/DeviceItem'));
const EmployeeGroupItem = deferredComponent(() => import('@biz/employees/group-item/EmployeeGroupItem'));
const EmployeeGroups = deferredComponent(() => import('@biz/employees/group/EmployeeGroups'));
const EmployeeItem = deferredComponent(() => import('@biz/employees/list-item/EmployeeItem'));
const EmployeeList = deferredComponent(() => import('@biz/employees/list/EmployeeList'));
const EmployeeRoles = deferredComponent(() => import('@biz/employees/role/EmployeeRoles'));
const HistoryList = deferredComponent(() => import('@biz/history'));
const BizHomePage = deferredComponent(() => import('@biz/home'));
const ScheduleList = deferredComponent(() => import('@biz/schedule-list'));

// 与 gUtils.categoriesConf 对应
const routerComponentMap = [
  {
    router: '/',
    component: Devices,
  },
  {
    router: '/contacts',
    component: Contacts,
  },
  {
    router: '/contact-add',
    component: SesameMobileContactAdd,
    load: true,
  },
  {
    router: '/me',
    components: [
      { router: 'index', component: SesameMobileMeIndex },
      { router: 'homepage', component: SesameMobileMyHomepage },
      { router: '', component: Me },
    ],
  },
  {
    router: '/biz',
    component: BizHomePage,
  },
  {
    router: '/vision',
    components: [{ router: '', component: Vision }],
    load: true,
  },
  {
    router: '/biz/employees',
    components: [
      { router: 'list', component: EmployeeList },
      { router: 'list-item', component: EmployeeItem },
      { router: 'group', component: EmployeeGroups },
      { router: 'group-item', component: EmployeeGroupItem },
      { router: 'role', component: EmployeeRoles },
    ],
  },
  {
    router: '/biz/devices',
    components: [
      { router: 'list', component: Devices },
      { router: 'list-item', component: DeviceItem },
      { router: 'device-share', component: DeviceShare },
      { router: 'group-share', component: GroupShare },
      { router: 'group', component: DeviceGroup },
      { router: 'group-item', component: DeviceGroupItem },
    ],
  },
  {
    router: '/biz/access-control',
    components: [
      { router: 'index', component: Devices },
      { router: 'region', component: SesameAccessControlDeviceRegion },
      { router: 'cards', component: VCards },
      { router: 'passwords', component: Passwords },
      { router: 'password-details', component: PasswordDetails },
      { router: 'ir-type', component: IrTypeList },
      { router: 'remotes', component: RemoteList },
      { router: 'remote-air', component: RemoteAir },
      { router: 'remote-non-air', component: RemoteNonAir },
      { router: 'remote-match', component: RemoteMatch },
      { router: 'learn', component: Learn },
    ],
  },
  {
    router: '/biz/cards',
    components: [
      { router: '', component: Cards },
      { router: 'details', component: CardDetails },
    ],
  },
  {
    router: '/biz/history',
    components: [
      { router: '', component: HistoryList },
      { router: 'env-snapshot', component: EnvSnapshotDetail },
    ],
  },
  {
    router: '/biz/schedule-list',
    component: ScheduleList,
  },
  {
    router: '/biz/developer',
    component: Developer,
  },
  {
    router: '/device-history',
    component: DeviceHistory,
    load: true,
  },
  {
    router: '/device-notify',
    component: SesameMobileNotifyCenter,
    load: true,
  },
  {
    router: '/device-setting',
    components: [
      { router: '', component: DeviceSetting },
      { router: 'angle', component: AppLockAngle },
      { router: 'credentials', component: AppCredentials },
      { router: 'bot-script', component: AppBotScript },
      { router: 'auto-unlock', component: AppAutoUnlock },
      { router: 'index', component: SesameMobileDeviceSetting },
      { router: 'user', component: DeviceUserList },
      { router: 'rename', component: SesameMobileDeviceModifyName },
      { router: 'share', component: SesameMobileDeviceShareQRCode },
      { router: 'battery-trend', component: SesameMobileBatteryChart },
      { router: 'factory-info', component: FactoryInfoDetail },
    ],
    load: true,
  },
  {
    router: '/biz/wifi-module',
    components: [
      { router: '', component: MobileWifiModule },
      { router: 'index', component: WifiModuleIndex },
      { router: 'ssm-upgrade', component: UpgradeSSMFirmware },
    ],
    load: true,
  },
];

export { routerComponentMap };
